import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Cfdi, CfdiApi, MechanicsApi } from 'src/shared/sdk';
import { NgxXml2jsonService } from 'ngx-xml2json';
import metodoPagos from "../../assets/catalogos_sat/c_MetodoPago.json";

@Component({
  selector: 'app-notas-credito',
  templateUrl: './notas-credito.component.html',
  styleUrls: ['./notas-credito.component.scss']
})
export class NotasCreditoComponent implements OnInit {

  uuid: any;
  loading: boolean;
  folio: any;
  cfdis: unknown[];
  displayedColumns: string[] = ['fechaTimbrado', 'folio', 'uuid', 'reference'];
  cfdi: any;
  cfdiForm: FormGroup;
  metodoPagos = metodoPagos;
  conceptos: FormArray;
  subtotal = [];
  subtotalN: number;
  serverError: any;
  referencia: any;

  constructor(
    private fb: FormBuilder,
    private ngxXml2jsonService: NgxXml2jsonService,
    private mechanicsApi: MechanicsApi,
    private cfdiApi: CfdiApi
  ) { }

  ngOnInit() {
    this.iniciaCfdi();
  }

  iniciaCfdi() {
    this.cfdiForm = this.fb.group({
      formaPago: [null, [Validators.required]],
      metodoPago: ['PUE', [Validators.required]],
      uuid: [null, [Validators.required]],
      lugarExpedicion: [null, [Validators.required]],
      folio: [null, [Validators.required]],
      receptor_rfc: [null, [Validators.required]],
      receptor_nombre: [null, [Validators.required]],
      receptor_email: [null, [Validators.required, Validators.email]],
      cp: [null, Validators.required],
      regimenFiscal: [null, Validators.required],
      usoCfdi: ['G02', [Validators.required]],
      subtotal: [0, [Validators.required]],
      iva: [0, [Validators.required]],
      total: [0, [Validators.required]],
      origen: ['MXPFacturas', [Validators.required]],
      tipo: ['MXPFacturas', [Validators.required]],
      conceptos: this.fb.array([])
    });
  }

  async buscaFacturaNT() {
    this.loading = true;
    let where = {
      "data.tipoComprobante": "I-Ingreso",
      "estatus": {
        neq: "Cancelado"
      }
    };
    if (this.uuid) {
      where["data.uuid"] = {
        like: this.uuid
      };
    }
    if (this.referencia) {
      where["data.pos_reference"] = {
        like: this.referencia
      };
    }
    if (this.folio) {
      where["data.folio"] = parseInt(this.folio, 10);
    }
    console.log(where);
    this.cfdis = await this.cfdiApi.find({
      where: where, limit: 10
    }).toPromise();
    this.loading = false;
    console.log(this.cfdis);
  }

  seleccionaCfdi(row) {
    this.cfdis = [];
    this.uuid = '';
    this.folio = '';
    this.cfdi = row;
    const parser = new DOMParser();
    const xml = parser.parseFromString(this.cfdi.data.cfdi, 'text/xml');
    this.cfdi.xml = this.ngxXml2jsonService.xmlToJson(xml);
    this.cfdiForm.get('formaPago').setValue(this.cfdi.xml['cfdi:Comprobante']['@attributes'].FormaPago);
    this.cfdiForm.get('uuid').setValue(this.cfdi.data.uuid);
    this.cfdiForm.get('receptor_rfc').setValue(this.cfdi.xml['cfdi:Comprobante']['cfdi:Receptor']['@attributes'].Rfc);
    this.cfdiForm.get('receptor_nombre').setValue(this.cfdi.xml['cfdi:Comprobante']['cfdi:Receptor']['@attributes'].Nombre);
    this.cfdiForm.get('lugarExpedicion').setValue(this.cfdi.xml['cfdi:Comprobante']['@attributes'].LugarExpedicion);
    this.cfdiForm.get('folio').setValue(this.cfdi.xml['cfdi:Comprobante']['@attributes'].Folio);
    this.cfdiForm.get('cp').setValue(this.cfdi.xml['cfdi:Comprobante']['cfdi:Receptor']['@attributes'].DomicilioFiscalReceptor);
    this.cfdiForm.get('regimenFiscal').setValue(this.cfdi.xml['cfdi:Comprobante']['cfdi:Receptor']['@attributes'].RegimenFiscalReceptor);
    this.agregaConcepto();
    console.log(this.cfdi);
  }

  createItem(): FormGroup {
    return this.fb.group({
      descripcion: [null, [Validators.required]],
      clavesProSer: ['84111506', [Validators.required]],
      cantidad: [1, [Validators.required]],
      claveUnidad: ['ACT', [Validators.required]],
      valorUnitario: [0, [Validators.required]],
      importe: [0, [Validators.required]],
    });
  }

  agregaConcepto() {
    this.conceptos = this.cfdiForm.get('conceptos') as FormArray;
    this.conceptos.push(this.createItem());
  }

  calculaImporte(i) {
    this.subtotal[i] = this.cfdiForm.get('conceptos')['controls'][i].controls.cantidad.value * this.cfdiForm.get('conceptos')['controls'][i].controls.valorUnitario.value;
    this.cfdiForm.get('conceptos')['controls'][i].controls.importe.setValue(this.subtotal[i]);
    this.subtotalN = 0;
    for (let j = 0; j < this.subtotal.length; j++) {
      const sub = this.subtotal[j];
      this.subtotalN += sub;
    }
  }

  borraConcepto(i) {
    this.conceptos.removeAt(i);
  }

  async creaNotaCredito() {
    this.loading = true;
    this.cfdiForm.get('subtotal').setValue(this.subtotalN);
    this.cfdiForm.get('iva').setValue(this.subtotalN * 0.16);
    this.cfdiForm.get('total').setValue(this.subtotalN * 1.16);
    this.serverError = null;
    let res = await this.mechanicsApi.creaNotaCredito(this.cfdiForm.value).toPromise();
    console.log(res);
    this.iniciaCfdi();
    this.loading = false;
  }
}
